/**
 * THE NAMES ON THE WIRE — the few strings both ends must agree about.
 *
 * The door (`http.ts`) and the browser client (`screens/client.ts`) both need
 * the idempotency header's name and its shape. Until now the client imported
 * them from `http.ts`, which drags the whole server — the command registry, the
 * document renderer, `node:crypto` — into anything that bundles the browser
 * half. A constant does not need a module graph behind it.
 *
 * Nothing that imports this file may import anything else.
 */

/** The cookie the door sets; the browser never reads it (it is HttpOnly). */
export const COOKIE = 'cts_session';

/** The header a retry-sensitive command carries (DEF-088). */
export const IDEMPOTENCY_HEADER = 'idempotency-key';

/** What a key must look like: 8–128 of letters, digits, dot, underscore, hyphen. */
export const IDEMPOTENCY_KEY_SHAPE = /^[A-Za-z0-9._-]{8,128}$/;
